// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1wgTY","actions":"GroupTable_actions__3nF7n","deleteModalFooter":"GroupTable_deleteModalFooter__5_s50"};